import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import Divider from 'src/components/ui/Divider/Divider';
import { SaleOrder } from 'src/services/saleOrder';
import styles from './ShippingLines.module.scss';
import OrderLinesTable from '../OrderLinesTable/OrderLinesTable';
import { OverlaySectionHeadline } from '../../OverlaySectionHeadline/OverlaySectionHeadline';

export interface ShippingLinesProps {
  saleOrder: SaleOrder;
}

const ShippingLines: React.FC<ShippingLinesProps> = ({ saleOrder }) => {
  const { t } = useTranslation();

  // TODO: IMPLEMENT!
  const sendSaleOrderStatus = () => {};

  return (
    <div className={classNames(styles.root)}>
      {saleOrder?.carrier &&
        'shipping_lines' in saleOrder.carrier &&
        saleOrder?.carrier?.shipping_lines &&
        saleOrder?.carrier?.shipping_lines.length > 0 && (
          <>
            <OverlaySectionHeadline>{t('general.deliveries')}</OverlaySectionHeadline>
            {saleOrder.order_lines && saleOrder.order_lines.length > 0 && (
              <Button
                icon="send"
                onClick={sendSaleOrderStatus}
                title={t('general.send_delivery_status')}
                tone={ButtonToneProps.SECONDARY}
              />
            )}
            <OrderLinesTable item={saleOrder} />
            <Divider className="my-24" />
          </>
        )}
    </div>
  );
};

export default ShippingLines;
